<div class="dialog-container">
  <h1 mat-dialog-title>
    CONFERMA ASSEMBLEA
    <mat-icon class="close-icon" (click)="cancel()">close</mat-icon>
  </h1>
  <h1 class="istruzioni">Per approvare trascina nella lista "approvati"</h1>

  <div class="dialog-body-overflow">

    <!--    PROFILES  -->


    <br>
    <h1 class="section-title text-green">Sezione Profili</h1>
    <br>

    <div cdkDropListGroup>
      <div class="associazione-competenze-container">

        <strong>PROFILI DA APPROVARE</strong>

        <div cdkDropList [cdkDropListData]="profiles" class="competenze-list" id="listaProfili"
             (cdkDropListDropped)="drop($event)">

          <div class="competenze-box" *ngFor="let profile of profiles" cdkDrag>
            <div class="icon-container primary-details">
              <mat-icon class="pointer" matTooltip="Dettaglio competenza">remove_red_eye</mat-icon>
            </div>

            <p style="display:block; width:100%;">
              <span class="primary-details">{{ profile.nomeProfilo }}</span>
<!--              <span class="secondary-details">-->
<!--                        ({{ profile.tipologia.descrizione }} - {{ skill.stato.descrizione }})-->
<!--              </span>-->
            </p>


          </div>
        </div>

        <div class="d-flex">
          <div class="align-right">
            <button mat-icon-button matTooltip="Approva tutti" (click)="approveAllProfiles()">
              <mat-icon class="green">keyboard_double_arrow_right</mat-icon>
            </button>
          </div>
        </div>

        <mat-paginator #paginator [pageSize]="paginationSize" [length]="skillsPagination" [pageIndex]="0"
                       showFirstLastButtons
                       (page)="onPaginateChange($event)"></mat-paginator>
      </div>

      <div class="associazione-competenze-container">
        <strong>PROFILI APPROVATI</strong>
        <div cdkDropList [cdkDropListData]="selectedProfiles" class="competenze-list" (cdkDropListDropped)="drop($event)">
          <div class="competenze-box" *ngFor="let profile of selectedProfiles"
               cdkDrag>
            <div class="icon-container primary-details">
              <mat-icon class="pointer" matTooltip="Dettaglio competenza">remove_red_eye</mat-icon>
            </div>

            <p style="display:block; width:100%;">
              <span class="primary-details">{{ profile.nomeProfilo }}</span>
<!--              <span class="secondary-details">-->
<!--                        ({{ skill.tipologia.descrizione }} - {{ skill.stato.descrizione }})-->
<!--              </span>-->
            </p>
          </div>
        </div>

        <button mat-icon-button matTooltip="Disapprova tutti" (click)="unapproveAllProfiles()">
          <mat-icon class="green">keyboard_double_arrow_left</mat-icon>
        </button>

        <mat-paginator #paginator [pageSize]="paginationSize" [length]="skillsPagination" [pageIndex]="0"
                       showFirstLastButtons
                       (page)="onPaginateChange($event)"></mat-paginator>

      </div>
    </div>


    <br>
    <h1 class="section-title text-green">Sezione Competenze</h1>
    <br>


    <!--    COMPETENZE-->
    <div cdkDropListGroup>
      <div class="associazione-competenze-container">

        <strong>COMPETENZE DA APPROVARE</strong>

        <div cdkDropList [cdkDropListData]="skills" class="competenze-list" id="listaCompetenze"
             (cdkDropListDropped)="drop($event)">

          <div class="competenze-box" *ngFor="let skill of skills" cdkDrag>
            <div class="icon-container primary-details">
              <mat-icon class="pointer" matTooltip="Dettaglio competenza">remove_red_eye</mat-icon>
            </div>

            <p style="display:block; width:100%;">
              <span class="primary-details">{{ skill.descrizione }}</span>
              <span class="secondary-details">
                        ({{ skill.tipologia.descrizione }} - {{ skill.stato.descrizione }})
              </span>
            </p>


          </div>
        </div>

        <div class="d-flex">
          <div class="align-right">
            <button mat-icon-button matTooltip="Approva tutti" (click)="approveAllSkills()">
              <mat-icon class="green">keyboard_double_arrow_right</mat-icon>
            </button>
          </div>
        </div>

        <mat-paginator #paginator [pageSize]="paginationSize" [length]="skillsPagination" [pageIndex]="0"
                       showFirstLastButtons
                       (page)="onPaginateChange($event)"></mat-paginator>
      </div>

      <div class="associazione-competenze-container">
        <strong>COMPETENZE APPROVATE</strong>
        <div cdkDropList [cdkDropListData]="selectedSkills" class="competenze-list" (cdkDropListDropped)="drop($event)">
          <div class="competenze-box" *ngFor="let skill of selectedSkills"
               cdkDrag>
            <div class="icon-container primary-details">
              <mat-icon class="pointer" matTooltip="Dettaglio competenza">remove_red_eye</mat-icon>
            </div>

            <p style="display:block; width:100%;">
              <span class="primary-details">{{ skill.descrizione }}</span>
              <span class="secondary-details">
                        ({{ skill.tipologia.descrizione }} - {{ skill.stato.descrizione }})
              </span>
            </p>
          </div>
        </div>

        <button mat-icon-button matTooltip="Disapprova tutti" (click)="unapproveAllSkills()">
          <mat-icon class="green">keyboard_double_arrow_left</mat-icon>
        </button>

        <mat-paginator #paginator [pageSize]="paginationSize" [length]="skillsPagination" [pageIndex]="0"
                       showFirstLastButtons
                       (page)="onPaginateChange($event)"></mat-paginator>

      </div>
    </div>


  </div>

  <div class="dialog-footer">
    <div mat-dialog-actions class="actions">
      <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="cancel()">
        <mat-icon>close</mat-icon>
        Annulla
      </button>
      <button mat-fab extended class="searchbox-buttons save-button" (click)="submit()"
              [disabled]="disableSubmitButton">
        <mat-icon>save</mat-icon>
        Approva
      </button>
    </div>
  </div>
</div>
